import React from 'react'

import { Chip, Paper, Stack, Tab, Tabs } from '@mui/material'

import { DATA_CHANGE_REQUEST_TYPES, type DataChangeRequestType } from 'constants/data-change-requests'

type DataChangeRequestTypeTabsProps = {
  counts: Partial<Record<DataChangeRequestType, number>>
  value: DataChangeRequestType
  awaitingReview?: boolean
  onChange: (type: DataChangeRequestType) => void
}

const DataChangeRequestTypeTabs = ({
  counts,
  value,
  awaitingReview = false,
  onChange,
}: DataChangeRequestTypeTabsProps) => (
  <Paper sx={{ borderRadius: '4px 4px 0 0' }}>
    <Tabs onChange={(_, type: DataChangeRequestType) => onChange(type)} sx={{ px: 2 }} value={value}>
      {DATA_CHANGE_REQUEST_TYPES.map(({ value: type, label }) => {
        const count = counts[type]
        const flagged = awaitingReview && !!count

        return (
          <Tab
            key={type}
            label={
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                {/* Stack spacing is a margin on element siblings, so a bare text label sits flush. */}
                <span>{label}</span>
                {count !== undefined && (
                  <Chip
                    color={flagged ? 'warning' : 'default'}
                    label={count}
                    size="small"
                    variant={flagged ? 'filled' : 'outlined'}
                  />
                )}
              </Stack>
            }
            value={type}
          />
        )
      })}
    </Tabs>
  </Paper>
)

export default DataChangeRequestTypeTabs
